import { InfoBanner } from "@/lib/Components/Banners/InfoBanner";

export function LogisticsOpenHoursInfoBanner() {
  return (
    <InfoBanner className="col-span-full mb-4">
      <p className="mb-1 font-medium">Confirmation Hours</p>
      <p>
        These are the times when your team will confirm relocations. For
        example, if you require 8 hours notice and your fleet team is closed
        over the weekend, the earliest time someone can book is 8 hours after
        you open on Monday.
      </p>
    </InfoBanner>
  );
}
